<!-- components/FooterTabs.vue -->
<template>
  <div id="tabMenu" class="lg:hidden">


    <div class="tabFootermenu z-50 bg-white" :class="{ 'bg-jacarta-900': darkMode }">
      <NuxtLink to="/" class="tab" id="inicio" :class="{ active: isActive('/') }">
        <HomeIcon aria-hidden="true" class="h-7" v-if="!isActive('/')" />
        <HomeIcon2 aria-hidden="true" class="h-7" v-else />
        <span>Início</span>
      </NuxtLink>
      <NuxtLink to="/search" class="tab" id="busca" :class="{ active: isActive('/search') }">
        <MagnifyingGlassIcon aria-hidden="true" class="h-7" v-if="!isActive('/search')" />
        <MagnifyingGlassIcon2 aria-hidden="true" class="h-7" v-else />
        <span>Busca</span>
      </NuxtLink>

      <NuxtLink to="/perfil/ingressos" id="ingressos" class="tab" :class="{ active: isActive('/perfil/ingressos') }">
        <TicketIcon aria-hidden="true" class="h-7" v-if="!isActive('/perfil/ingressos')" />
        <TicketIcon2 aria-hidden="true" class="h-7" v-else />
        <span>Ingressos</span>
      </NuxtLink>
   <!--    <NuxtLink to="/perfil/favoritos" id="favoritos" class="tab" :class="{ active: isActive('/perfil/favoritos') }">
        <HeartIcon aria-hidden="true" class="h-7" v-if="!isActive('/perfil/favoritos')" />
        <HeartIcon2 aria-hidden="true" class="h-7" v-else />

        <span>Favoritos</span>
      </NuxtLink> -->

      <NuxtLink to="/perfil" id="perfil" class="tab" :class="{ active: isPerfilSelect() }">
        <UserIcon aria-hidden="true" class="h-7" v-if="!isPerfilSelect()" />
        <UserIcon2 aria-hidden="true" class="h-7" v-else />
        <span>Perfil</span>
      </NuxtLink>

    </div>


  </div>
</template>

<script setup>
const darkMode = useCookie('theme')
import { HeartIcon, HomeIcon, TicketIcon, UserIcon, MagnifyingGlassIcon } from '@heroicons/vue/24/outline';
import { HeartIcon as HeartIcon2, HomeIcon as HomeIcon2, UserIcon as UserIcon2, TicketIcon as TicketIcon2, MagnifyingGlassIcon as MagnifyingGlassIcon2 } from '@heroicons/vue/24/solid';
const route = useRoute();

const isActive = (path) => route.path === path;

const isPerfilSelect = () => {
  const rotasPerfiltab = ['/auth/login', '/auth/recuperar-senha', '/auth/criar-conta', '/perfil', '/perfil/suporte', '/perfil/pedidos', '/perfil/editar', '/perfil/dados', '/perfil/notificacoes', '/perfil/seguranca']

  if (rotasPerfiltab.includes(route.path)) {
    return true
  }
};
</script>

<style >
.menuTexto {
  margin-right: 0;
}
</style>
